var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerOffLight = function SvgPowerOffLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.6 5.4v-.6h-1.2V24h1.2V5.4M7.8 24.533c0-6.27 3.562-11.708 8.775-14.4l-.548-1.065C10.425 11.963 6.6 17.798 6.6 24.533c0 9.607 7.792 17.4 17.4 17.4s17.4-7.793 17.4-17.4c0-6.736-3.825-12.578-9.42-15.465l-.555 1.065c5.212 2.692 8.775 8.13 8.775 14.4 0 8.947-7.253 16.2-16.2 16.2-8.948 0-16.2-7.253-16.2-16.2"
  })));
};
export default SvgPowerOffLight;